import { useState } from "react";
import { faqs } from "@/mocks/gossipData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-12">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              关于吃瓜大全，
              <br />
              你可能想问这些
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              从内容筛选到更新频率，我们整理了被问到最多的问题，帮你更快了解这份精选合集的运作方式。
            </p>
            <div className="mt-6 hidden lg:block">
              <div className="rounded-2xl bg-background-50 p-5 border border-background-200/70">
                <div className="text-sm font-medium text-foreground-800">还有疑问？</div>
                <p className="mt-1 text-xs text-foreground-600">订阅后可直接回复邮件告诉我们，主编会亲自看。</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={i} className="rounded-2xl border border-background-200/70 bg-background-50">
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className={`font-medium leading-snug ${open ? "text-primary-700" : "text-foreground-950"}`}>
                        {f.q}
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                          open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200/70 text-foreground-700"
                        }`}
                      >
                        <i className="ri-add-line"></i>
                      </span>
                    </button>
                    {open && (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}